"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _TypographyTheme2 = _interopRequireDefault(require("./TypographyTheme"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var StepLabelTheme = function StepLabelTheme(colors, breakpoints) {
  var _TypographyTheme, _TypographyTheme$styl;

  return {
    styleOverrides: {
      root: {
        display: 'flex',
        alignItems: 'center',
        '&.MuiStepLabel-alternativeLabel': {
          flexDirection: 'column-reverse'
        },
        '&.Mui-disabled': {
          cursor: 'default'
        }
      },
      label: _objectSpread(_objectSpread({}, ((_TypographyTheme = (0, _TypographyTheme2["default"])(colors, breakpoints)) === null || _TypographyTheme === void 0 ? void 0 : (_TypographyTheme$styl = _TypographyTheme.styleOverrides) === null || _TypographyTheme$styl === void 0 ? void 0 : _TypographyTheme$styl.h5) || {}), {}, {
        color: colors.lynch,
        '&.Mui-active': {
          color: colors.bleuDigital100,
          fontWeight: 500
        },
        '&.Mui-completed': {
          color: colors.bleuDigital100,
          fontWeight: 500
        },
        '&.MuiStepLabel-alternativeLabel': {
          textAlign: 'center',
          marginTop: 8
        }
      }),
      iconContainer: {
        boxSizing: 'content-box'
      },
      horizontal: {
        '& .MuiStepLabel-labelContainer': {
          marginBottom: 8
        }
      },
      vertical: {
        alignItems: 'flex-start',
        padding: 0
      }
    }
  };
};

var _default = StepLabelTheme;
exports["default"] = _default;